import { questionStatus } from 'json/obs-department'
import { doctorLevels } from 'json/doctor-hospital'
export let filterLabels = [
  {
    label: '状态',
    type: 'select',
    options: questionStatus,
    value: 'status'
  },
  {
    label: 'CPS所在地',
    value: 'city',
    type: 'select',
    filterable: true,
    props: {
      label: 'name',
      value: 'id'
    },
    options: []
  },
  {
    label: '医生地区',
    value: 'doctorAdress',
    type: 'address-select',
    addressShowElement: {
      province: true,
      city: true
    }
  },
  {
    label: '提问时间',
    value: 'questionTime',
    type: 'time-slot',
    startName: 'askTimeStart',
    endName: 'askTimeEnd'
  },
  {
    label: '预产期',
    value: 'exportDate',
    type: 'time-slot',
    startName: 'expectedDateStart',
    endName: 'expectedDateEnd'
  },
  {
    label: '用户等级',
    value: 'memberLevelCode',
    type: 'select',
    props: {
      value: 'code',
      label: 'name'
    },
    options: []
  },
  {
    label: '医生职位',
    value: 'positionCode',
    type: 'select',
    options: doctorLevels
  }
]
export let tableLabels = [
  {
    label: '预产期',
    minWidth: 100,
    value: 'expected_date'
  },
  {
    label: '创建时间',
    minWidth: 110,
    value: 'created_date'
  },
  {
    label: '最近更新',
    value: 'lastModified_date'
  },
  {
    label: '状态',
    minWidth: 110,
    value: 'ask_status'
  }
]
